/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Reports_YetInputs */

const en_no_reports_yet = /** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The air waves are clear. No reports pending.`)
};

const id_no_reports_yet = /** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelombang udara bersih. Tidak ada laporan tertunda.`)
};

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const es_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const fr_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const de_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const ja_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const zh_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const ar_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const it_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const ru_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const pt_no_reports_yet = en_no_reports_yet;

/** @type {(inputs: No_Reports_YetInputs) => LocalizedString} */
const ko_no_reports_yet = en_no_reports_yet;

/**
* | output |
* | --- |
* | "The air waves are clear. No reports pending." |
*
* @param {No_Reports_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_reports_yet = /** @type {((inputs?: No_Reports_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Reports_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_reports_yet(inputs)
	if (locale === "es") return es_no_reports_yet(inputs)
	if (locale === "fr") return fr_no_reports_yet(inputs)
	if (locale === "de") return de_no_reports_yet(inputs)
	if (locale === "ja") return ja_no_reports_yet(inputs)
	if (locale === "zh") return zh_no_reports_yet(inputs)
	if (locale === "ar") return ar_no_reports_yet(inputs)
	if (locale === "id") return id_no_reports_yet(inputs)
	if (locale === "it") return it_no_reports_yet(inputs)
	if (locale === "ru") return ru_no_reports_yet(inputs)
	if (locale === "pt") return pt_no_reports_yet(inputs)
	return ko_no_reports_yet(inputs)
});